(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/game-analyzes/assets/javascripts/game-analyzes.js') >= 0) return;  svs.modules.push('/components/sport/game-analyzes/assets/javascripts/game-analyzes.js'); 
'use strict';

const {
  mapAnalysis,
  mapDrawAnalyzes,
  mapRaceAnalyzes
} = svs.sport.gameAnalyzes;
const {
  productIds,
  isTipsetProduct,
  helpers
} = svs.utils.products;
const CACHE_EXPIRE = 5 * 60 * 1000;
const gameAnalyzes = {};
const logger = new svs.core.log.Logger('svs.sport.gameAnalyzes');
const matchesPerProduct = {
  [productIds.STRYKTIPSET]: 13,
  [productIds.EUROPATIPSET]: 13,
  [productIds.T8]: 8,
  [productIds.T8STRYK]: 8,
  [productIds.T8EXTRA]: 8,
  [productIds.POWERPLAY]: 8
};
const mapAnalysesByEvent = gameAnalyzes => {
  const analyzesByEvent = {};
  gameAnalyzes.forEach(gameAnalysis => {
    (gameAnalysis.gameAnalyses || []).forEach(eventAnalysis => {
      if (!eventAnalysis || !eventAnalysis.properties || !eventAnalysis.properties.cnt_eventNumber || typeof eventAnalysis.properties.cnt_eventNumber !== 'number' || !gameAnalysis.authorProfile) {
        return;
      }
      const eventNumber = eventAnalysis.properties.cnt_eventNumber;
      if (!analyzesByEvent[eventNumber]) {
        analyzesByEvent[eventNumber] = [];
      }
      const newEventAnalysis = {
        authorProfile: {
          authorLongName: gameAnalysis.authorProfile.authorLongName,
          id: gameAnalysis.authorProfile.id,
          images: gameAnalysis.authorProfile.images
        },
        body: eventAnalysis.body
      };
      if (isTipsetProduct(gameAnalysis.productId)) {
        newEventAnalysis.homeSelected = eventAnalysis.homeSelected;
        newEventAnalysis.drawSelected = eventAnalysis.drawSelected;
        newEventAnalysis.awaySelected = eventAnalysis.awaySelected;
      } else if (helpers.isBomben(gameAnalysis.productId)) {
        newEventAnalysis.home = eventAnalysis.home;
        newEventAnalysis.away = eventAnalysis.away;
      }
      analyzesByEvent[eventNumber].push(newEventAnalysis);
    });
  });
  return analyzesByEvent;
};
function filterAnalyses(filterSystems, matchId, analyses) {
  let filteredAnalyses = analyses;
  if (Array.isArray(filterSystems) && filterSystems.length > 0) {
    filteredAnalyses = filteredAnalyses.filter(a => filterSystems.some(s => a.properties.cnt_gameSystems.indexOf(s) >= 0));
  }
  filteredAnalyses = filteredAnalyses.filter(analysis => {
    if (matchId) {
      if (isTipsetProduct(analysis.productId)) {
        if (!analysis.homeSelected && !analysis.drawSelected && !analysis.awaySelected) {
          return false;
        }
      } else if (helpers.isBomben(analysis.productId) && !analysis.hasSelectionsForBothMatches) {
        return false;
      }
    } else {
      const isTipset = isTipsetProduct(analysis.productId);
      if (isTipset) {
        const hasAllMatches = analysis.gameAnalyses.length === matchesPerProduct[analysis.productId];
        if (!hasAllMatches) {
          return false;
        }
      }
      for (let i = 0; i < analysis.gameAnalyses.length; ++i) {
        if (isTipset && !analysis.gameAnalyses[i].homeSelected && !analysis.gameAnalyses[i].drawSelected && !analysis.gameAnalyses[i].awaySelected) {
          return false;
        }
        if (helpers.isBomben(analysis.productId) && !analysis.gameAnalyses[i].hasSelectionsForBothMatches) {
          return false;
        }
      }
    }
    return true;
  });
  return filteredAnalyses;
}

const getGameAnalyzes = _ref => {
  let {
    drawNumber,
    product,
    matchId,
    callback,
    filterSystems = [],
    race
  } = _ref;
  function doCallback(analyses, analyzesByEvent) {
    const filteredAnalyses = filterAnalyses(filterSystems, matchId, analyses);
    const filteredAuthors = filteredAnalyses.map(a => a.authorProfile.id);
    const filteredEventAnalyses = {};
    for (const key in analyzesByEvent) {
      if (Object.prototype.hasOwnProperty.call(analyzesByEvent, key)) {
        filteredEventAnalyses[key] = analyzesByEvent[key].filter(analysis => {
          if (filteredAuthors.indexOf(analysis.authorProfile.id) > -1) {
            return true;
          }
          return false;
        });
      }
    }
    callback(null, filteredAnalyses, filteredEventAnalyses);
  }
  let cacheKey;
  if (matchId) {
    cacheKey = matchId;
  } else if (race && race.raceId) {
    cacheKey = race.raceId;
  } else {
    cacheKey = "".concat(product, "_").concat(drawNumber);
  }
  if (!gameAnalyzes[cacheKey]) {
    gameAnalyzes[cacheKey] = {
      analyzes: []
    };
  } else if (gameAnalyzes[cacheKey].expires > new Date()) {
    doCallback(gameAnalyzes[cacheKey].analyzes, gameAnalyzes[cacheKey].analyzesByEvent);
    return;
  }
  let method;
  const options = {
    count: 20
  };
  if (matchId) {
    method = svs.content.shared.cms.getGameAnalyses;
    options.id = matchId;
    options.idType = 'match';
  } else if (race) {
    method = svs.content.shared.cms.getDrawAnalyses;
    options.raceProduct = race.raceProduct;
    options.idType = 'race';
    options.id = race.raceId;
  } else {
    method = svs.content.shared.cms.getDrawAnalyses;
    options.id = drawNumber;
  }
  if (product) {
    options.product = product;
  }
  method(options, (error, response) => {
    if (error) {
      logger.error("Errored when trying to fetch draw analyzes ".concat(error));
      callback(error);
      return;
    }
    gameAnalyzes[cacheKey].expires = new Date(Date.now() + CACHE_EXPIRE);
    const callbackArgs = [];
    let cachedAnalyses;
    if (matchId) {
      cachedAnalyses = response.result.map(mapAnalysis);
      gameAnalyzes[cacheKey].analyzes = cachedAnalyses;
    } else if (race) {
      cachedAnalyses = mapRaceAnalyzes(response.result);
      gameAnalyzes[cacheKey].analyzes = cachedAnalyses;
    } else {
      cachedAnalyses = mapDrawAnalyzes(response.result);
      gameAnalyzes[cacheKey].analyzes = cachedAnalyses;
    }
    callbackArgs.push(cachedAnalyses);
    if (!matchId && !race) {
      const cachedAnalyzesByEvent = mapAnalysesByEvent(cachedAnalyses);
      gameAnalyzes[cacheKey].analyzesByEvent = cachedAnalyzesByEvent;
      callbackArgs.push(cachedAnalyzesByEvent);
    }
    doCallback(...callbackArgs);
  });
};
const getCachedGameAnalyzes = () => gameAnalyzes;
setGlobal('svs.sport.gameAnalyzes', {
  getGameAnalyzes,
  getCachedGameAnalyzes,
  logger
});
 })(window);